import type { BuilderLocationSettings } from "api-types/builders/builderTypes";
import { getLocationTypeLabelFromLocation } from "api-types/locations/locationDisplay";
import formatAddress from "common/utils/formatAddress";
import type { EffectiveLocationAddress } from "lib/components/builders/communities/utils/locationUtils";

export interface LotAddressPreview {
  value: string;
  /** Note on where the previewed address comes from, or null when it's the lot's own. */
  source: string | null;
  /** True when nothing in the hierarchy has an address — rendered muted/italic. */
  muted: boolean;
}

/**
 * Builds the address preview shown under the lot address input — what the map will
 * display for this lot. Mirrors `SvgMap`'s `formatAddressForSelectedLot`.
 */
export function getLotAddressPreview(
  lotAddress: string | null | undefined,
  inheritedAddress: EffectiveLocationAddress | null,
  locationSettings: BuilderLocationSettings | null | undefined,
): LotAddressPreview {
  if (lotAddress) {
    return { value: lotAddress, source: null, muted: false };
  }
  if (inheritedAddress) {
    const typeLabel = getLocationTypeLabelFromLocation(inheritedAddress.source, locationSettings, {
      fallback: "location",
    });
    return { value: formatAddress(inheritedAddress.address), source: `from ${typeLabel}`, muted: false };
  }
  return { value: "No address", source: null, muted: true };
}
